<template>
  <div class="userEdit">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'user', params: {} }">
        User
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'userEdit', params: { id: id } }">
        Edit User
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <user-form :id="id"></user-form>
  </div>
</template>

<script>
import UserForm from "./UserForm.vue";

export default {
  name: "user",
  data() {
    return {
      id: null
    };
  },
  components: {
    UserForm
  },
  created() {
    this.id = this.$route.params.id;
    this.$emit("showParent", false);
  }
};
</script>
